import { styled } from '../../styled';
// @deprecated use Card Component with size prop instead
export var CardContent = styled('div', { name: 'QuantumCardContent' })({});
